import { isClient } from '@vueuse/core'

if (isClient) window.dataLayer = window?.dataLayer || []

export function gtag(..._arg: any[]) {
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer?.push(arguments)
}

export const gtmObject = ref<GtmObject>({
  page_name: '',
  page_env: import.meta.env.PROD ? 'prod' : 'dev',
  page_content_type: 'typeless',
  country_custom: '',
  p_product_family: 'uncategorized',
  p_product: 'uncategorized',
  cg1: '',
  cg2: 'uncategorized',
  cg3: '',
  cg4: 'uncategorized',
  cg5: '',
  login_status: 'logged-out',
  event: '',
  platform: '',
  uid: '',
})

export interface GtmObject {
  page_name: string
  page_env: string
  page_content_type: string
  country_custom: string
  p_product_family: string
  p_product: string
  cg1: string
  cg2: string
  cg3: string
  cg4: string
  cg5: string
  login_status: string
  event: string
  platform: string
  uid?: string
  event_type?: string
  event_category?: string
  event_label?: string
  event_action?: string
  step?: string
  amount_offers?: string | number
  product_family?: string
  product?: string
  item_name?: string
  price?: string | number
  item_category?: string
  item_category_2?: string
  item_category_3?: string
  item_list_name?: string
  item_list_id?: string
  currency?: string
  affiliation?: string
  completion_type?: 'online' | 'lead' | 'partner-clickout'
  item_id?: string
  index?: string
  items?: Array<any>
  action?: string
}
